(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('valuation-endpoint-calls', {
            parent: 'admin',
            url: '/reports/valuation-endpoint-calls?page&sort&valuationApiClientId',
            reloadOnSearch: false,
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valuationApiCalls.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/valuation-endpoint-calls/valuation-endpoint-calls.html',
                    controller: 'ValuationApiCallsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                valuationApiClientId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    var sortString = $stateParams.sort || 'requestedAt,desc';
                    return {
                        page: PaginationUtil.parsePage($stateParams.page) || 1,
                        sort: sortString,
                        predicate: PaginationUtil.parsePredicate(sortString),
                        ascending: PaginationUtil.parseAscending(sortString),
                        valuationApiClientId: $stateParams.valuationApiClientId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('valuationApiCalls');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
